import { Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { ExpandableMinMaxFilterComponent, MinMaxFilterConfig } from "src/app/shared-components/expandable-min-max-filter/expandable-min-max-filter.component";
import { BuildYearFilterModel } from "./search-filter-buildyear.model";

@Component({
    selector: "search-filter-buildyear",
    imports: [ExpandableMinMaxFilterComponent],
    templateUrl: "./search-filter-buildyear.component.html",
    styleUrl: "./search-filter-buildyear.component.scss",
})
export class SearchFilterBuildYearComponent {
     filterForm = input.required<FieldTree<BuildYearFilterModel>>();

    protected filterConfig = computed<MinMaxFilterConfig<BuildYearFilterModel>>(() => ({
        filterForm: this.filterForm,
        title: "Byggeår",
        fromFieldAccessor: (form) => form.buildYearFrom,
        toFieldAccessor: (form) => form.buildYearTo,
        expandedAccessor: (form) => form.expanded,
        fromFieldId: "buildYearFrom",
        toFieldId: "buildYearTo",
        cssClass: "buildyear"
    }));
}
